import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const advanceBookingSlice = createSlice({
  name: "advanceBooking",
  initialState: {
    message: null,
    loading: false,
    model: false,
    customerModel: false,
    drawer: false,
    error_msg: null,
    listCount: 0,
    personCount: 0,
    advanceBookingList: [],
    RejectMode: false,
    advanceBookingParams: {
      start_date: "",
      end_date: "",
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
      advance_request: "",
      approval_status: "",
      refund_mode: "",
      customer: "",
      vehicle: "",
      ordering: "",
    },
    rejectReasonObjData: {},
    filterStatus: false,
    rowdata: {},
    advanceBookingViewData: {},
    viewModel: false,
    customerByIdList: {},
    customerList: [],
    searchPersonId: 0,
    personParams: {
      start_date: "",
      end_date: "",

      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
    customerViewData: {},
    checkApprove: false,
    previewFile:{},

  },
  reducers: {
    getadvanceBookingList: (state, action) => {
      if (state.advanceBookingParams?.page == 1) {
        return {
          ...state,
          loading: true,
          advanceBookingList: [],
        };
      } else {
        return {
          ...state,
          loading: true,
        };
      }
    },

    // advanceBookingListSuccessful: (state, action) => {
    //     const response = action.payload;
    //     const noofpages = Math.ceil(response.count / state.advanceBookingParams.page_size);

    //     return {
    //         ...state,
    //         listCount: response.count,
    //         advanceBookingList: response.results || [],
    //         loading: false,
    //         advanceBookingParams: {
    //             ...state.advanceBookingParams,
    //             no_of_pages: noofpages,
    //         },
    //     };
    // },

    advanceBookingListSuccessful: (state, action) => {
      const response = action.payload;
      const noofpages = Math.ceil(
        response.count / state.advanceBookingParams.page_size,
      );

      return {
        ...state,
        listCount: response.count,
        advanceBookingList: response.results || [],
        loading: false,
        advanceBookingParams: {
          ...state.advanceBookingParams,
          no_of_pages: noofpages,
        },
      };
    },

    getCustomerList: (state, action) => {
      if (state.personParams?.page == 1) {
        return {
          ...state,
          loading: true,
          customerList: [],
        };
      } else {
        return {
          ...state,
          loading: true,
        };
      }
    },

    getCustomerListSuccessful: (state, action) => {
      const response = action.payload;
      const noofpages = Math.ceil(
        response.count / state.personParams.page_size,
      );

      return {
        ...state,
        personCount: response.count,
        customerList: response.results || [],
        loading: false,
        personParams: {
          ...state.personParams,
          no_of_pages: noofpages,
        },
      };
    },

    personAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    personAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        customerModel: false,
        customerViewData: {},
        customerByIdList: {},
      };
    },
    clearPersonList: (state, action) => {
      return {
        ...state,
        loading: true,
        customerViewData: {},
        customerByIdList: {},
      };
    },

    clearadvanceBookingList: (state, action) => {
      return {
        ...state,
        loading: true,
        advanceBookingList: [],
      };
    },

    getadvanceBookingHistory: (state, action) => {
      return {
        ...state,
        loading: true,
        advanceBookingHistoryList: [],
      };
    },

    SetloanParams: (state, action) => {
      return {
        ...state,
        advanceBookingParams: action.payload,
      };
    },

    addadvanceBooking: (state, action) => {
      return {
        ...state,
        formSubmitLoading: true,
      };
    },
    addadvanceBookingSuccessful: (state, action) => {
      return {
        ...state,
        formSubmitLoading: false,
      };
    },
    advanceBookingClear: (state, action) => {
      return {
        ...state,
        loading: false,
        advanceBookingData: {},
        vehicleVersion: {},
        insuranceData: {},
      };
    },

    getVehicleData: (state, action) => {
      return {
        ...state,
        loading: true,
        vehicleData: {},
      };
    },
    vehicleDataSuccessful: (state, action) => {
      return {
        ...state,
        vehicleData: action.payload.response,
        loading: false,
      };
    },

    advanceBookingApproval: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    getadvanceBookingCheckApprove: (state) => {
      return {
        ...state,
        loading: true,
        checkApprove: false,
      };
    },
    advanceBookingsCheckApproveSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        checkApprove: action.payload,
      };
    },
    isRejectModelVisible: (state, action) => {
      return {
        ...state,
        RejectMode: action.payload,
        advanceBookingRejectData: {},
        loading: false,
      };
    },
    rejectModelInputChangeValue: (state, action) => {
      return {
        ...state,
        advanceBookingRejectData: {
          ...state.advanceBookingRejectData,
          [action.payload.key]: action.payload.value,
        },
        loading: false,
      };
    },

    advanceBookingDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    setadvanceBookingParams: (state, action) => {
      return {
        ...state,
        advanceBookingParams: action.payload,
      };
    },
    isDrawerVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          drawer: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          drawer: action.payload,
        };
      }
    },
    getCustomerById: (state, action) => {
      return {
        ...state,
        loading: true,
        customerByIdList: action.payload,
      };
    },
    getcustomerByIDSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        // model: true,
        rowdata: {
          // id: action.payload.id,
          ...action.payload.response,
          firstname: action.payload.response.firstname,
          middlename: action.payload.response.middlename,
          lastname: action.payload.response.lastname,
          mobile: action.payload.response.mobile,
          alternatemobile: action.payload.response.alternatemobile,

          aadharno: action.payload.response.aadharno,
          gender: action.payload.response.gender,

          addressline1: action.payload.response.addressline1,
          addressline2: action.payload.response.addressline2,

          pincode: action.payload.response.pincode,
        },

        customerViewData: action.payload.response,
      };
    },
    getAdvanceBookingByID: (state) => {
      return {
        ...state,
        loading: true,
        rowdata: {},
      };
    },

    SetPersonParams: (state, action) => {
      return {
        ...state,
        personParams: action.payload,
      };
    },

    customerViewModel: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          viewModel: action.payload,
        };
      } else {
        return {
          ...state,
          viewModel: action.payload,
          customerViewData: {},
        };
      }
    },

    advanceBookingByIDSuccessful: (state, action) => {
      const response = action.payload.response;
      return {
        ...state,
        loading: false,
        rowdata: {
          id: response.id,
          advance_amount: response.advance_amount,
          request_date: response.request_date,
          payment_mode_name: response.payment_mode_name,
          payment_mode: response.payment_mode,
          status: response.status,
          createdon: response.createdon,
          modifiedon: response.modifiedon,
          createdby: response.createdby,
          modifiedby: response.modifiedby,
          remarks: response.remarks,
          no_of_days: response.no_of_days,
          customer_id: response.customer?.id ?? null,
          vehicle_id: response.vehicle?.id ?? null,
          customer_name: response.customer?.firstname,
          vehicleno: response.vehicle?.vehicleno,
          vehicle_no: response.vehicle?.vehicleno,
          customer_phone: response.customer?.phone || response.customer?.mobile,
          customer_profilepicture: response.customer?.profilepicture,
          customer_firm: response.customer?.firm?.flat() || [],
          vehicle_image1_preview: response.vehicle_image1,
          vehicle_image2_preview: response.vehicle_image2,
        },
        model: action.payload.type === "update",
        viewModel: action.payload.type === "view",
        advanceBookingViewData: response,
      };
    },

    InputChangeValue: (state, action) => {
      // detect if customer modal is open
      if (state.customerModel) {
        return {
          ...state,
          customerViewData: {
            ...state.customerViewData,
            [action.payload.key]: action.payload.value,
          },
        };
      } else {
        return {
          ...state,
          rowdata: {
            ...state.rowdata,
            [action.payload.key]: action.payload.value,
          },
        };
      }
    },

    getRejectReasonData: (state, action) => {
      return {
        ...state,
        loading: true,
        rejectReasonObjData: action.payload,
      };
    },

    checkFilterStatus: (state, action) => {
      return {
        ...state,
        filterStatus: action.payload,
      };
    },
    apiError: (state, action) => {
      return {
        ...state,
        loading: false,
        formSubmitLoading: false,
        error_msg: action.payload,
      };
    },
    isModelVisible: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
          // loanViewData: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
          // loanViewData: {},
        };
      }
    },
    isViewModelVisible(state, action) {
      if (!action.payload) {
        return {
          ...state,
          viewModel: false,
          loading: false, // ✅ STOP LOADING WHEN MODAL CLOSES
        };
      }
      return {
        ...state,
        viewModel: true,
      };
    },

    isCustomerModelVisible: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          customerModel: action.payload,
          customerViewData: {},
          customerByIdList: {},
        };
      } else {
        return {
          ...state,
          customerModel: action.payload,
          customerViewData: {},
          customerByIdList: {},
        };
      }
    },

    FilterInputChangeValue: (state, action) => {
      return {
        ...state,
        advanceBookingParams: {
          ...state.advanceBookingParams,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    addImageUpload: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.imageType]: action.payload.file,
        },
      };
    },
    setPreviewImg: (state, action) => {
      const previewField = `${action.payload.imageType}_preview`;
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [previewField]: action.payload.preview,
        },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getadvanceBookingList,
  advanceBookingListSuccessful,
  clearadvanceBookingList,
  addadvanceBooking,
  addadvanceBookingSuccessful,
  advanceBookingClear,
  InputChangeValue,
  getVehicleData,
  vehicleDataSuccessful,
  advanceBookingApproval,
  getadvanceBookingCheckApprove,
  advanceBookingsCheckApproveSuccessful,
  isRejectModelVisible,
  rejectModelInputChangeValue,
  setadvanceBookingParams,
  advanceBookingDelete,
  isDrawerVisible,
  FilterInputChangeValue,
  getCustomerById,
  getRejectReasonData,
  checkFilterStatus,
  apiError,
  getAdvanceBookingByID,
  advanceBookingByIDSuccessful,
  isModelVisible,
  isViewModelVisible,
  isCustomerModelVisible,
  getCustomerListSuccessful,
  personAdd,
  personAddSuccessful,
  getCustomerList,
  SetPersonParams,
  addImageUpload,
  setPreviewImg
} = advanceBookingSlice.actions;

export default advanceBookingSlice.reducer;
